export const C_Library = {
    E_BookNameTaken: "Book name occupied",
    E_BookBeforeDeclaration: "Book '%0' called before declaration",
    E_LibraryBaseBeforeSet: "Library base called before declaration",
    E_FaultyCollectionSpec: "Collection speficication format faulty",
    E_AbsentFileDescriptor: "Archive file does not contain a description",
}